import { FetchModelResponse } from '@cian/http-api';
import { NotFoundError } from '@cian/peperrors/shared';

import { TGetComparisonDesktopResponse } from '../../../repositories/offers-comparison/v2/get-comparison-desktop';
import { IGetComparisonDesktopResponseSchema } from '../../../repositories/offers-comparison/entities/get_comparison_desktop/GetComparisonDesktopResponseSchema';

export function assertNotFoundError(
  response: TGetComparisonDesktopResponse,
): asserts response is FetchModelResponse<200, 'json', IGetComparisonDesktopResponseSchema> {
  if (response.statusCode === 200) {
    return;
  }

  const { message, errors } = response.response;

  throw new NotFoundError({
    domain: 'src/node/services/compare/fetchComparison.ts',
    message: message || '',
    details: { errors: JSON.stringify(errors) },
  });
}
